<template>
  <AppDialog
    class="insights-cta-banner-dialog"
    append-to-body
    :show="show"
    :title="bannersContent.copy[type].dialog.title"
    @close="$emit('close')"
  >
    <p>
      {{ bannersContent.copy[type].dialog.description }}
    </p>
    <h5 class="mt-20">{{ bannersContent.copy[type].dialog.p1.title }}</h5>
    <p class="content-light">
      {{ bannersContent.copy[type].dialog.p1.description }}
    </p>
    <img
      class="mt-10"
      :src="bannersAssets.illustration.dialog.wte.src"
      :alt="bannersAssets.illustration.dialog.wte.alt"
    />
    <h5 class="mt-50">{{ bannersContent.copy[type].dialog.p2.title }}</h5>
    <p class="content-light">
      {{ bannersContent.copy[type].dialog.p2.description }}
    </p>
    <img
      class="mt-10"
      :src="bannersAssets.illustration.dialog.app_urls.src"
      :alt="bannersAssets.illustration.dialog.app_urls.alt"
    />
    <h5 class="mt-50">{{ bannersContent.copy[type].dialog.p3.title }}</h5>
    <p class="content-light">
      {{ bannersContent.copy[type].dialog.p3.description }}
    </p>
    <img
      class="mt-10"
      :src="bannersAssets.illustration.dialog.highlights.src"
      :alt="bannersAssets.illustration.dialog.highlights.alt"
    />
    <h5 class="mt-50">{{ bannersContent.copy[type].dialog.p4.title }}</h5>
    <p class="content-light">
      {{ bannersContent.copy[type].dialog.p4.description }}
    </p>
    <img
      class="mt-10"
      :src="bannersAssets.illustration.dialog.focus_time.src"
      :alt="bannersAssets.illustration.dialog.focus_time.src"
    />
    <div class="close-button-wrapper">
      <AppButton
        type="primary"
        @click="$emit('close')"
      >
        Got it!
      </AppButton>
    </div>
  </AppDialog>
</template>

<script>
import AppDialog from '~/components/AppDialog.vue';
import AppButton from '~/components/AppButton.vue';
import { INSIGHTS as insightsContent, INSIGHTS_ASSETS as insightsAssets } from '~/app_constants';

export default {
  name: 'InsightsAppURLsBannerDialog',
  components: {
    AppDialog,
    AppButton,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    bannersAssets: insightsAssets.banners,
    bannersContent: insightsContent.banners,
  }),
};
</script>
